import { SET_QUICK_PAYMENT_STATUS } from '../../types';

const setQuickPaymentStatus = (status) => (dispatch) => {
  dispatch({ type: SET_QUICK_PAYMENT_STATUS, status });
};

export { setQuickPaymentStatus };
